/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.pages

import japgolly.scalajs.react.ScalaComponent
import japgolly.scalajs.react.vdom.html_<^._
import net.scalytica.blaargh.CssSettings._
import net.scalytica.blaargh.styles.BlaarghBootstrapCSS

import scalacss.ScalaCssReact._

object NotFoundPage {

  val component = ScalaComponent
    .builder[Unit]("NotFoundPage")
    .stateless
    .render { _ =>
      val binaryPageNotFound = Seq(
        "01110000",
        "01100001",
        "01100111",
        "01100101",
        "00100000",
        "01101110",
        "01101111",
        "01110100",
        "00100000",
        "01100110",
        "01101111",
        "01110101",
        "01101110",
        "01100100"
      )
      // scalastyle:off magic.number
      <.div(^.key := "nf-1",
        BlaarghBootstrapCSS.container + BlaarghBootstrapCSS.textXsCenter,
        binaryPageNotFound
          .grouped(7)
          .map { grp =>
            <.h2(
              grp.map(bin => <.span(^.marginRight := "1.2rem", bin)).toTagMod
            )
          }
          .toTagMod
      )
    // scalastyle:on magic.number
    }
    .build

  def apply() = component()
}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/pages/NotFoundPage.scala